import { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  const cargarDatosPerfil = async (baseUsuario) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/colegiado/perfil`,
        {
          headers: {
            Authorization: `Bearer ${baseUsuario.token}`,
          },
        }
      );
      const data = await res.json();

      setUsuario({
        ...baseUsuario,
        nombre: data.nombre,
        foto: data.foto,
      });
    } catch (error) {
      console.error("Error al cargar perfil:", error);
      setUsuario(baseUsuario); // Carga básica si falla
    }
  };


  const login = (token) => {
    localStorage.setItem("token", token);
    const decoded = jwtDecode(token);
    const roles = decoded.authorities || [];
    const rol = roles.includes("ROLE_ADMIN") ? "ADMIN" : "COLEGIADO";
    const baseUsuario = {
      email: decoded.sub,
      rol,
      codigo: decoded.codigo,
      token,
    };

    if (rol === "COLEGIADO") {
      cargarDatosPerfil(baseUsuario);
    } else {
      setUsuario(baseUsuario);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUsuario(null);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      const roles = decoded.authorities || [];
      const rol = roles.includes("ROLE_ADMIN") ? "ADMIN" : "COLEGIADO";
      const baseUsuario = {
        email: decoded.sub,
        rol,
        codigo: decoded.codigo,
        token,
      };

      if (rol === "COLEGIADO") {
        cargarDatosPerfil(baseUsuario);
      } else {
        setUsuario(baseUsuario);
      }
    }
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
